module.exports = __webpack_public_path__ + "img/car.9a5e64e8.svg";